import { COLOR_KEYS } from '@hts/shared/consts';
import colors from '@hts/shared/styles/Colors.module.scss';
import { ColorType } from '@hts/shared/types';
import { useMemo } from 'react';

export const useColorType = (color?: ColorType): string | undefined => {
  const colorTypeMap: Record<ColorType, string> = useMemo(
    () =>
      COLOR_KEYS.reduce(
        (acc, key) => {
          acc[key] = key;
          return acc;
        },
        {} as Record<ColorType, string>
      ),
    []
  );

  return color && colors[colorTypeMap[color]];
};
